import APIKit from "../Allapis/Apikit/apikit";

export const getAllTickets = async (id) => {
  try {
    const url = id ? `/tickets/getTickets/${id}` : `/tickets/getTickets`;
    const res = await APIKit.get(url);
    return res.data;
  } catch (e) {
    console.log(e);
  }
};

export const createAndupdateTickets = async (id, values) => {
  let res;
  try {
    const url = id ? `/tickets/${id}` : `/tickets`;
    if (id) {
      res = await APIKit.put(url, values);
    } else {
      res = await APIKit.post(url, values);
    }
    return res.data;
  } catch (e) {
    console.log(e);
  }
};

export const deleteSupportServer = async (id) => {
  console.log("del_id", id);
  let res;
  try {
    res = await APIKit.delete(`/tickets/${id}`);
    console.log({ resdelete: res });
    return res.data;
  } catch (e) {
    console.log(e);
  }
};
